import { http } from '../../config/axios'

export default function getClienteDocumentos(idCliente: string): Promise<any[]> {
  return http
    .get(`api/client/documento/${idCliente}`)
    .then((res) => res.data as any[])
    .catch((error) => {
      console.error('Erro getClienteDocumentos', error)
      throw Error(error.response?.data || 'Erro ao listar documentos')
    })
}
